import fetchWebApi from 'api/fetchWebApi';

export interface PostTinkInquiriesPayload {
  productName?: string;
  personalId?: string;
  loanApplicationId?: number;
  accountVerificationReportId?: string;
  transactionReportId?: string;
  riskInsightsId?: string;
  incomeCheckId?: string;
}

const postTinkInquiriesApiCall = async (
  payload: PostTinkInquiriesPayload,
): Promise<void> =>
  fetchWebApi('/tink/inquiries', undefined, {
    method: 'post',
    body: JSON.stringify(payload),
  });

export default postTinkInquiriesApiCall;
